
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

export const Row = styled.div`
  display: flex;
`;

export const Column = styled.div`
  flex: ${(props) => props.size || 1};
`;

export const GridLayout = styled.div`
  height: 100vh;
  width: 100vw;
  display: grid;
  grid-template-areas:
    "header"
    "main"
    "footer";
  grid-template-rows: 11rem auto auto;
  grid-template-columns: 1fr;

  @media (max-width: 767px) {
    grid-template-rows: 7rem auto 7rem;
  }
`;

export const Header = styled.header`
  grid-area: header;
  background: #fff;

  position: fixed;
  width: 100%;
  height: 11rem;
  z-index: 999;

  @media (max-width: 767px) {
    height: 7rem;
  }
`;

export const Burger = styled.div`
  background-color: transparent;
  position: relative;
  width: 40px;
  height: 24px;
  margin-right: 3rem;
  display: none;

  @media (max-width: 767px) {
    display: block;
  }
`;

export const BurgerInner = styled.div`
  display: block;
  top: ${({ open }) => (open ? "0px" : "10px")};

  ${({ open }) =>
    open &&
    css`
      transform: translate3d(0, 10px, 0) rotate(45deg);
    `}

  &,
  &:before,
  &:after {
    position: absolute;
    width: 40px;
    height: 4px;
    transition-timing-function: ease;
    transition-duration: 0.15s;
    transition-property: transform;
    border-radius: 4px;
    background-color: #f1adb2;
    display: block;
    content: "";
  }

  &:before {
    top: -10px;

    ${({ open }) =>
    open &&
    css`
        top: 10px;
        transition-timing-function: ease;
        transition-duration: 0.15s;
        transition-property: transform, opacity;
        transform: rotate(-45deg) translate3d(-5.71429px, -6px, 0);
        opacity: 0;
      `}
  }

  &:after {
    bottom: -10px;

    ${({ open }) =>
    open &&
    css`
        top: 20px;
        transform: translate3d(0, -20px, 0) rotate(-90deg);
      `}
  }
`;

export const Nav = styled.nav`
  display: flex;

  @media (max-width: 767px) {
    background-color: #FFF;
    border-top: 2px solid #f1adb2;
    height: calc(100vh);
    width: 100%;
    flex-direction: column;
    justify-content: center;
    transform: ${({ open }) => (open ? "translateY(0)" : "translateY(-100vh)")};
    text-align: left;
    padding: 2rem;
    position: absolute;
    top: 7rem;
    right: 0;
    transition: transform 0.5s ease-in-out;
    overflow: hidden;
  }
`;

export const Main = styled.main`
  grid-area: main;
`;

export const Footer = styled.footer`
  grid-area: footer; 
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  color: #fff;
`;

export const FooterImage = styled.img`
  height: 70px;
  margin-left: 1rem;
  margin-bottom: 2rem;

  @media (max-width: 767px) {
    height: 50px;
    margin-bottom: 1rem;
  }
`;

export const Social = styled.div`
  text-align: right;
  margin-right: 3rem; 
  margin-left: 3rem;

  @media (max-width: 767px) {
    margin-top: 1rem;
    margin-right: 0;
    text-align: center;
  }
`;

export const Copyright = styled.div`
  @media (max-width: 767px) {
    text-align: center;
  }
`;

export const Menu = styled.ul`
  grid-area: footer;
  display: flex;
  list-style-type: none;
  align-items: center;

  @media (max-width: 767px) {
    flex-direction: column;
    height: 100%;
  }
`;

export const Figure = styled.figure`
    z-index: 999;
`;

export const Container = styled.div`
  max-width: 1100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0.3rem 0 0.3rem 0;
`;

export const ImageFull = styled.img`
  padding-top: 10px;
  width: 200px;

  @media (max-width: 1100px) {
    display: none;
  }
`;

export const ImageMini = styled.img`
  padding-top: 10px;
  width: 50px;
  margin-left: 1rem; 

  @media (min-width: 1100px) {
    display: none;
  }
`;

export const MenuItem = styled.li`
  cursor: pointer;
  padding: 3rem 3rem;
`;

export const MenuLink = styled(Link)`
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 700;
  transition: color 0.3s;

  color: #294c7c;

  &:hover {
    color: #a4bbda;
  }
`;

export const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  background: #f1adb2;
  padding-top: 2rem;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;